import { Parser } from '~/api';
import { Server } from '~/api/models/Server';
import RequestService from './request';

interface ToggleBackupRequest {
    uuid: string;
}

class ServerBackupService {
    getAll(): Promise<ListResponse> {
        return RequestService.get('/servers/:server/backups', {
            'filter[creating]': true,
        }).then(Parser.parse);
    }

    toggle(data: ToggleBackupRequest): Promise<Server> {
        return RequestService.post(`/servers/:server/backups/${data.uuid}/toggle`, data).then(Parser.parse).then(RequestService.updateModelBinding);
    }
}

export default new ServerBackupService();
